var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auxiliary-layout"},[_c('div',{staticClass:"header-wrap"},[_c('auxiliary-header')],1),_c('div',{staticClass:"page-content-wrap"},[_c('transition',{attrs:{"name":"down","mode":"out-in"}},[_c('router-view',{key:_vm.$route.meta.category})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }